import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function ticketsQuantityValidator(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const quantity: string = form.parent?.get("quantity")?.value;
    const maxTickets: string = form.parent?.get("maxTickets")?.value;

    if (+maxTickets === 0) {
      return { maxTicketsIsZero: true };
    } else if (+quantity < +maxTickets) {
      return { maxTicketsExceededQuantity: true };
    }

    return null;
  };
}
